module.exports = __webpack_public_path__ + "static/media/bristol.2fae8655.png";